import * as bowser from 'bowser';
import {Utils} from './Utils';
import {IBowserMinVersions, IBrowserInfo} from './CommonTypes';

export class BrowserUtils {
    public static getInfo(userAgent?: string): IBrowserInfo {
        userAgent = Utils.valueOrDefault(userAgent, window.navigator.userAgent);
        return bowser._detect(userAgent);
    }

    public static getNameAndVersion(): string {
        let info = BrowserUtils.getInfo();
        return info.name + ' ' + info.version;
    }

    public static checkMin(minVersions: IBowserMinVersions, userAgent?: string): boolean {
        userAgent = Utils.valueOrDefault(userAgent, window.navigator.userAgent);
        return bowser.check(minVersions, true, userAgent) === true;
    }

    public static checkExact(exactVersions: IBowserMinVersions, userAgent?: string): boolean {
        userAgent = Utils.valueOrDefault(userAgent, window.navigator.userAgent);
        let info = bowser._detect(userAgent);

        for (var browser in exactVersions) {
            if (exactVersions.hasOwnProperty(browser)) {
                if (info[browser]) {
                    if (typeof exactVersions[browser] !== 'string') {
                        throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(exactVersions));
                    }

                    if (bowser.compareVersions([info.version as any, exactVersions[browser]]) === 0) {
                        return true;
                    }
                }
            }
        }

        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/BrowserUtils.ts
 **/